<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong
              ><i class="cui-graph icons font-2xl mt-4"></i> Shipment Tracking
            </strong>
            <div class="card-header-actions"></div>
          </div>
          <div class="box">
            <form
              @submit.prevent="validateForm('form-1')"
              data-vv-scope="form-1"
            >
              <b-row>
                <b-col md="6">
                  <b-col sm="12">
                    <b-form-group label="Shipment Id" :label-cols="4">
                      <b-form-input
                        class="input"
                        type="text"
                        name="shipmentid"
                        v-model="customer.shipmentid"
                        v-validate="'required|'"
                        :class="{
                          input: true,
                          'is-danger': errors.has('form-1.shipmentid'),
                        }"
                        placeholder="Enter Shipment Id "
                      >
                      </b-form-input>
                      <span
                        v-show="errors.has('form-1.shipmentid')"
                        class="help text-danger"
                        >{{ errors.first("form-1.shipmentid") }}</span
                      >
                    </b-form-group>
                  </b-col>
                </b-col>
                <b-col md="6">
                  <b-button
                    type="submit"
                    size="md"
                    class="mr-4"
                    variant="primary"
                  >
                    Search</b-button
                  >
                  <b-button
                    type="button"
                    size="md"
                    variant="danger"
                    @click="clear"
                  >
                    Clear</b-button
                  >
                </b-col>
              </b-row>
            </form>
          </div>
          <b-col md="12">
            <b-table
              show-empty
              stacked="md"
              style="table-layout: fixed"
              :busy="isBusyMaster"
              :items="ConsignmentMasterGetdata"
              :bordered="bordered"
              :fields="fields"
              :outlined="outlined"
            >
              <template slot="thead-top">
                <div>
                  <b-modal id="bv-modal-example" hide-footer>
                    <template v-slot:modal-title>
                      <h3 style="margin-left: 180px;">Signature</h3>
                    </template>
                    <div class="d-block text-center">
                      <img
                        alt="This image is not available"
                        style="width: 458px;height: 250px;"
                        v-bind:src="img1"
                      />
                      <br />
                      <span
                        style="float: right;font-size: 20px;"
                        title="Download Image"
                        ><a :href="img1" target="blank"
                          ><i class="fa fa-download" aria-hidden="true"></i></a
                      ></span>
                    </div>
                  </b-modal>
                </div>
              </template>
              <template slot="thead-top">
                <div>
                  <b-modal id="bv-modal-example1" hide-footer>
                    <template v-slot:modal-title>
                      <h3 style="margin-left: 150px;">Shipment Images</h3>
                    </template>
                    <template v-if="imgpath != null">
                      <div
                        class="d-block text-center"
                        style="margin-bottom: 15px;"
                        v-for="imgdata in imgpath"
                      >
                        <img
                          alt="This image is not available"
                          style="width: 458px;height: 250px;"
                          v-bind:src="imgdata.imagepath"
                        />
                        <br />
                        <span
                          style="float: right;font-size: 20px;"
                          title="Download Image"
                          ><a :href="imgdata.imagepath" target="blank"
                            ><i
                              class="fa fa-download"
                              aria-hidden="true"
                            ></i></a
                        ></span>
                      </div>
                    </template>
                    <template v-else>
                      <p>Image is not available</p>
                    </template>
                  </b-modal>
                </div>
              </template>

              <template slot="thead-top">
                <div>
                  <b-modal id="bv-modal-example2" hide-footer>
                    <template v-slot:modal-title>
                      <h3 style="margin-left: 150px;">Rpickdone Images</h3>
                    </template>
                    <!-- {{rpickdoneimgpath}} -->
                    <template v-if="rpickdoneimgpath != null">
                      <div
                        class="d-block text-center"
                        style="margin-bottom: 15px;"
                        v-for="imgdata in rpickdoneimgpath"
                      >
                        <!-- {{imgdata}} -->
                        <img
                          alt="This image is not available"
                          style="width: 458px;height: 250px;"
                          v-bind:src="imgdata.imagepath"
                        />
                        <br />
                        <span
                          style="float: right;font-size: 20px;"
                          title="Download Image"
                          ><a :href="imgdata.imagepath" target="blank"
                            ><i
                              class="fa fa-download"
                              aria-hidden="true"
                            ></i></a
                        ></span>
                      </div>
                    </template>
                    <template v-else>
                      <p>Image is not available</p>
                    </template>
                  </b-modal>
                </div>
              </template>

              <template slot="shippingidsign" slot-scope="row">
                <b>Shipping ID:-</b><br />
                {{ row.item.shippingid }}<br />
                <b>Order ID:- </b><br />
                {{ row.item.orderid }}

                <div v-if="country == 'KSA'">
                  <br>
                  <b>Order Type:-</b><br>
                  {{ row.item.ordertype }}
                </div>
              </template>
              <!-- <template slot="agentname" slot-scope="row">
                 {{row.item.agentname}}-{{row.item.deliveryagentmasterid}}
                 
                </template> -->
              <!--  <template slot="agentname" slot-scope="row">
                 {{row.item.shipmentstatus=="BookingPending" ? "-":row.item.agentname+"-"+row.item.deliveryagentmasterid}}
                 
                </template> -->
              <template slot="agentname" slot-scope="row">
                {{
                  row.item.deliveryagentmasterid == null
                    ? row.item.agentname
                    : row.item.agentname + "-" + row.item.deliveryagentmasterid
                }}
              </template>
              <template slot="picklocation" slot-scope="row">
                {{ row.item.pickuplocationname }}
                &nbsp;<!-- <span data-toggle="tooltip"  @click="$bvModal.show('bv-modal-example1')">
            <div v-if="row.item.shipmentstatus=='Delivered'" style="display: block;"> <i class="fa fa-picture-o" style="background-color: none;color: #20a8d8;"></i></div>
                  </span> -->
                <span data-toggle="tooltip"> </span>
              </template>

              <template slot="status" slot-scope="row">
                    {{row.item.shipmentstatus}} / {{row.item.deliverystatus}}<br>
                 
                </template>
              
              <template slot="exchangedetails" slot-scope="row">
                  {{row.item.is_exchange}} <br>
                <b v-if="row.item.exchange_id">Ex. ID:- </b><br> {{row.item.exchange_id}} <br>
                <b v-if="row.item.exshipment">Ex. Shipment:- </b><br> {{row.item.exshipment}} 
                 
              </template>

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </b-table>
          </b-col>
          <span style="color:red; float: right;" v-if="is_mark_ofd == 2">
            <b>Client Pick Cancel Request Received for this Shipment</b>
          </span>

          <div
            v-if="
              this.dlvstatus == 'Delivered' ||
                this.dlvstatus == 'RTD' ||
                this.dlvstatus == 'HandoverPending'
            "
            style="    padding-left: 16px;"
          >
            <span
              v-if="img1 != null"
              data-toggle="tooltip"
              @click="$bvModal.show('bv-modal-example')"
            >
              <label>View Signature</label>&nbsp;

              <i
                class="fa fa-pencil"
                style="background-color: none; color: #20a8d8;"
              ></i
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;</span
            >
            <span
              v-if="imgpath != null"
              data-toggle="tooltip"
              @click="$bvModal.show('bv-modal-example1')"
            >
              <label>View Shipment Image</label>&nbsp;&nbsp;&nbsp;

              <i
                class="fa fa-picture-o"
                style="background-color: none;color: #20a8d8;"
              ></i
            ></span>
          </div>

          <div
            v-if="
              this.dlvstatus == 'HandoverPending' ||
                this.dlvstatus == 'RTOHandoverDoneToLocation' ||
                (this.dlvstatus == 'BookingDone' && servicetype == 'return') ||
                (this.dlvstatus == 'OFD' && servicetype == 'return') ||
                (this.dlvstatus == 'RTD' && servicetype == 'return')
            "
            style="    padding-left: 16px;"
          >
            <!-- <span    data-toggle="tooltip"  @click="showModal(this.rpickdoneimg)"> 
                  <label>View Rpickdone Image</label>&nbsp;&nbsp;&nbsp;
               <i class="fa fa-file-image-o" aria-hidden="true" data-toggle="tooltip" title="View Image" style="color:  #20a8d8;"></i></i></span> -->
            <span
              v-if="rpickdoneimgpath != null"
              data-toggle="tooltip"
              @click="$bvModal.show('bv-modal-example2')"
            >
              <!-- {{servicetype}} -->
              <label>View Rpickdone Image</label>&nbsp;
              <i
                class="fa fa-sign-out"
                style="background-color: none;color: #20a8d8;"
                aria-hidden="true"
              ></i>
              <!-- <i class="fa fa-picture-o" ></i> -->
            </span>
          </div>

          <b-col sm="12">
            <b-table
              show-empty
              hover
              stacked="md"
              style="table-layout: fixed"
              :busy="isBusyhistory"
              :outlined="outlined"
              :items="data"
              :bordered="bordered"
              :fields="fielddata"
              caption-top
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"> </b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="table-caption"
                ><b>This is shipment tracking histroy</b></template
              >
            </b-table>
          </b-col>
          <b-col sm="12">
            <b-table
              show-empty
              hover
              stacked="md"
              style="table-layout: fixed"
              :busy="isBusylogistic"
              :outlined="outlined"
              :items="logisticlogdata"
              :bordered="bordered"
              :fields="statusdata"
              caption-top
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"> </b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="table-caption"
                ><b>Status For Logistics</b></template
              >
              <template slot="pushflag" slot-scope="row">
                <span
                  >{{
                    row.item.pushflag == 0
                      ? "-"
                      : row.item.pushflag == 1
                      ? "Success"
                      : "Fail"
                  }}
                </span>
              </template>
            </b-table>
          </b-col>
          <b-col sm="12">
            <b-table
              show-empty
              hover
              stacked="md"
              style="table-layout: fixed"
              :busy="isBusycustom"
              :outlined="outlined"
              :items="customlogdata"
              :bordered="bordered"
              :fields="customFields"
              caption-top
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"> </b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="table-caption"
                ><b>Status For Custom</b></template
              >
              <template slot="pushflag" slot-scope="row">
                <span
                  >{{
                    row.item.pushflag == 0
                      ? "-"
                      : row.item.pushflag == 1
                      ? "Success"
                      : "Fail"
                  }}
                </span>
              </template>
            </b-table>
          </b-col>
          <b-col sm="12">
            <b-table
              show-empty
              hover
              stacked="md"
              style="table-layout: fixed"
              :busy="isBusysms"
              :outlined="outlined"
              :items="smslogdata"
              :bordered="bordered"
              :fields="smsFields"
              caption-top
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"> </b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="table-caption"
                ><b>Status For SMS</b></template
              >
              <template slot="issmssent" slot-scope="row">
                <span
                  >{{ row.item.is_sms_sent != 0 ? "Delivered" : "Pending" }}
                </span>
              </template>
            </b-table>
          </b-col>
          <b-col sm="12">
            <b-table
              show-empty
              hover
              stacked="md"
              style="table-layout: fixed"
              :busy="isBusyosr"
              :outlined="outlined"
              :items="osremaildata"
              :bordered="bordered"
              :fields="osremailfields"
              caption-top
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"> </b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="table-caption"
                ><b>Status For OSR Email</b></template
              >
              <!--  <template slot="emailsendingstatus" slot-scope="row">
                
                <span>{{ (row.item.emailsendingstatus!=0||row.item.emailsendingstatus!=null||row.item.emailsendingstatus!='')?'Delivered':'Pending'}} </span> 
                
                </template> -->
            </b-table>
          </b-col>

          <b-col sm="12" v-if="response_msg == 'Successful'">
            <b-table
              show-empty
              hover
              stacked="md"
              :busy="isBusy"
              style="table-layout: fixed"
              :outlined="outlined"
              :items="babygeardata"
              :bordered="bordered"
              :fields="babygearfields"
              caption-top
            >
              <template slot="table-caption"
                ><b>BabyGear Pushlog For Warranty</b></template
              >
              <!--  <template slot="emailsendingstatus" slot-scope="row">
                
                <span>{{ (row.item.emailsendingstatus!=0||row.item.emailsendingstatus!=null||row.item.emailsendingstatus!='')?'Delivered':'Pending'}} </span> 
                
                </template> -->
            </b-table>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
export default {
  data: function() {
    return {
      isBusy: false,
      is_history_Busy: false,
      customer: {},
      outlined: true,
      bordered: true,
      data: [],
      items: [],
      dlvstatus: [],
      servicetype: [],
      iswarrantyshipment: [],
      rpickdoneimg: [],
      img1: [],
      is_mark_ofd: 0,
      imgpath: [],
      rpickdoneimgpath: [],
      urlrpickdoneImg: [],
      urlImg: [],
      rpickdonepath: [],
      isBusycustom: false,
      customlogdata: [],
      isBusysms: false,
      smslogdata: [],
      isBusyosr: false,
      osremaildata: [],
      searchvaluesarr: [],
      shippingid: "",
      customFields: [
        { key: "shippingid", label: "Shipping Id" },
        { key: "drivername", label: "Driver Name" },
        { key: "vehiclenumber", label: "Vehicle Number" },
        { key: "shipmentstatus", label: "Shipment Status" },
        { key: "type", label: "Type" },
        { key: "created_datetime", label: "Date" },
        { key: "pushflag", label: "Status" },
      ],
      isBusylogistic: false,
      logisticlogdata: [],
      fields: [],
      statusdata: [
        { key: "shippingid", label: "Shipping Id" },
        { key: "courierstatus", label: "Courier Status" },
        { key: "createddate", label: "Created Date" },
        { key: "pushflag", label: "Status" },
        { key: "return_response", label: "Response" },
      ],
      fielddata: [
        { key: "shippingid", label: "Shipping Id" },
        { key: "pickuplocationname", label: "Pickup Location Name" },
        { key: "process", label: "Process" },
        { key: "comments", label: "Comments" },
        { key: "createdby", label: "Created By" },
        { key: "createddate", label: "Created Date" },
        { key: "latlong", label: "Lat Long" },
      ],
      smsFields: [
        { key: "shippingid", label: "Shipping Id" },
        { key: "mobilenumber", label: "Mobile Number" },
        { key: "smsapiresponse", label: "Sms Api Response" },
        { key: "issmssent", label: "SMS Sending Status" },
        { key: "sms_sent_date", label: "SMS Sent Date" },
        { key: "action", label: "Action" },
      ],
      osremailfields: [
        { key: "shippingid", label: "Shipping Id" },
        { key: "fcaccountid", label: "FC ID" },
        { key: "emailapiresponse", label: "Email Api Response" },
        { key: "emailsendingstatus", label: "Email Sending Status" },
        { key: "email_sent_date", label: "Email Sent Date" },
        { key: "action", label: "Action" },
      ],
      response_msg: "",
      babygeardata: [],
      babygearfields: [
        { key: "shippingid", label: "Shipping Id" },
        { key: "created_date", label: "Created Date" },
        { key: "created_by", label: "Created By" },

        { key: "return_response", label: "Response" },
      ],
      isBusyhistory: false,
      ConsignmentMasterGetdata: [],
      isBusyMaster: false,
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,
    };
  },
  created: function() {
    let userdata = localStorage.getItem("userData");
    let userInfo = JSON.parse(userdata);
      console.log("COUNTYYYYYYYYYY",userInfo)
      this.country=userInfo.country
      this.fields=[];
      if(userInfo.country==='KSA'){
            this.fields= [ 
              {key: 'shippingidsign', label: 'Shipping Id [Order Id]'}, 
              {key: 'pickuplocationname',label:'Pickup Location Name'}, 
              {key: 'servicetype',label:'Service Type'},
              // {key: 'shipmentstatus',label:'Shipment Status'},
              // {key: 'deliverystatus',label:'Delivery Status'},
              {key: 'status',label:'Shipment/Delivery Status'},
              {key: 'destinationhublocation',label:'Destination Hub'},
              {key: 'agentname', label: 'Agent Name'},
              {key: 'shipnameno', label: 'Customer Name & Mob No.'},
              
              {key: 'vendor_name', label: 'Vendor Name'},
              {key: 'mobilenumber', label: 'DA Mobile Number'},
              {key: 'shipaddress1', label: 'Delivery Address'},
              // {key: 'ordertype', label: 'Order Type'},
              {key: 'pickuplatlong', label: 'Delivery LatLong'},
              
              {key: 'createddate', label: 'Created Date'},
              {key: 'lastmodifieddate', label: 'Last Modified Date'},
              {key: 'exchangedetails', label: 'IsExchange'}

              ]
          }else{
            this.fields = [
            { key: "shippingidsign", label: "Shipping Id [Order Id]" },
            { key: "pickuplocationname", label: "Pickup Location Name" },
            { key: "servicetype", label: "Service Type" },
            { key: "shipmentstatus", label: "Shipment Status" },
            { key: "deliverystatus", label: "Delivery Status" },
            { key: "agentname", label: "Agent Name" },
            { key: "shipfirstname", label: "Customer Name" },
            { key: "vendor_name", label: "Vendor Name" },
            { key: "mobilenumber", label: "Mobile Number" },
            { key: "shipaddress1", label: "Shipping Address" },
            { key: "shiplonglat", label: "Delivery LatLong" },

            { key: "createddate", label: "Created Date" },
            { key: "lastmodifieddate", label: "Last Modified Date" },
            {key: 'exchangedetails', label: 'IsExchange'}
               ]
          }
  },

  methods: {
    validateForm(scope) {
      // var searchvaluesarr = []
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var shipmentid = this.customer.shipmentid;
          var searchvalues = shipmentid.split(",");
          for (var i = 0; i < searchvalues.length; i++) {
            this.searchvaluesarr.push(`${searchvalues[i]}`);
          }
          // const customerGetAllobj = {
          //   shippingid: searchvaluesarr
          // }
          this.babygeardata = [];
          this.shippingid = this.customer.shipmentid;

          this.tracking_main(this.shippingid);
          this.trackinghistory(this.searchvaluesarr);
          this.status_logistic(this.shippingid);
          this.status_custom(this.shippingid);
          this.status_sms(this.shippingid);
          //this.osr_email_details(this.shippingid);
        }
      });
    },

    tracking_main: function(value) {
      const Getobj = {
        shippingid: value,
      };

      this.isBusyMaster = true;
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/consignmentmasterget`, Getobj)
        .then((result) => {
          this.isBusyMaster = false;
          // console.log("result",result);
          if (result.body.length > 0) {
            this.ConsignmentMasterGetdata = result.body;
            if(this.ConsignmentMasterGetdata[0].orderflow==='Reverse' && this.country==='KSA'){
                  this.fields[11].label="PickUp LatLong"
                }
           else if(this.ConsignmentMasterGetdata[0].orderflow==='Forward' && this.country==='KSA'){
            this.fields[11].label="Delivery LatLong"
           } 
            this.is_mark_ofd = this.ConsignmentMasterGetdata[0].is_mark_ofd;
            this.iswarrantyshipment = this.ConsignmentMasterGetdata[0].iswarrantyshipment;
            console.log("iswarrantyshipment", this.iswarrantyshipment);
            // alert(this.ConsignmentMasterGetdata[0].is_mark_ofd);
            this.img1 = result.body[0].vendorsign;
            this.dlvstatus = result.body[0].shipmentstatus;
            this.servicetype = result.body[0].servicetype;
            console.log("this.dlvstatus", this.servicetype);
            this.rpickdoneimg = this.urlImg = result.body[0].shipment_images;
            this.imgpath = JSON.parse(this.urlImg);

            this.urlrpickdoneImg = result.body[0].shipment_images_rpickdone;
            // console.log(" urlrpickdoneImg", this.urlrpickdoneImg);
            this.rpickdoneimgpath = JSON.parse(this.urlrpickdoneImg);
            // console.log("  this.rpickdoneimgpath", this.rpickdoneimgpath[0].imagepath);
            this.isConsignmentMasterGetStatus = 1;

            // this.isBusy = false;
            if (
              this.iswarrantyshipment == "1" &&
              this.dlvstatus == "RTD" &&
              this.servicetype == "return"
            ) {
              // alert("in");
              this.babygearpushlog(value);
            }
          } else {
            //alert('Result not found')
            this.ConsignmentMasterGetdata = [];
            this.isConsignmentMasterGetStatus = 1;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    trackinghistory: function(value) {
      this.isBusyhistory = true;
      const customerGetAllobj = {
        shippingid: value,
      };

      // this.isBusy=true;
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/consignmentactivitytrackinggetweb`,
          customerGetAllobj
        )
        .then((result) => {
          this.isBusyhistory = false;
          if (
            result.body.returnmsg &&
            result.body.returnmsg === "UnSuccessful"
          ) {
            // this.isBusyhistory=false;
            this.data = [];

            //alert('Result not found')
            this.isConsignmentActivityTrackingGetWeb = 1;
            // this.is_history_Busy=false;
            // this.is_history_Busy =! this.is_history_Busy;
            // var searchlisting = document.getElementById('searchlisting')
            // searchlisting.style.display = 'block'
          } else if (result.body.length === 0) {
            this.isBusy = false;
            //alert('Result not found')
            this.data = [];
            this.isConsignmentActivityTrackingGetWeb = 1;
          } else {
            this.data = result.body;
            this.isConsignmentActivityTrackingGetWeb = 1;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    status_logistic: function(value) {
      this.isBusylogistic = true;
      const customerstatusobj = {
        shippingid: value,
      };
      // this.isBusy = true;
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/getlogisticlogdetails`,
          customerstatusobj
        )
        .then((result) => {
          this.isBusylogistic = false;
          if (result.body.returnvalue.length > 0) {
            this.logisticlogdata = result.body.returnvalue;
            //conole.log("this.logisticlogdata",this.logisticlogdata);
            this.isGetlogisticlogdetails = 1;
            // this.isBusy =false
          } else {
            //alert('Result not found')
            this.logisticlogdata = [];
            this.isGetlogisticlogdetails = 1;
            // this.isBusy = false
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    status_custom: function(value) {
      this.isBusycustom = true;
      const customobj = {
        shippingid: value,
      };

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/statusforcustom`, customobj)
        .then((result) => {
          this.isBusycustom = false;
          if (result.body.returnvalue.length > 0) {
            this.customlogdata = result.body.returnvalue;
            //conole.log("this.customlogdata",this.customlogdata);
            this.isGetlogisticlogdetails = 1;
            // this.isBusy = false
            this.searchvaluesarr = [];
          } else {
            //alert('Result not found')
            this.customlogdata = [];
            this.isGetlogisticlogdetails = 1;
            // this.isBusy = false;
            this.searchvaluesarr = [];
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    status_sms: function(value) {
      this.isBusysms = true;
      const smsobj = {
        shippingid: value,
      };

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/displaysmslog`, smsobj)
        .then((result) => {
          this.isBusysms = false;
          if (result.body.returnvalue.length > 0) {
            this.smslogdata = result.body.returnvalue;
            //conole.log("this.customlogdata",this.customlogdata);
            this.isGetlogisticlogdetails = 1;
            // this.isBusy = false
          } else {
            //alert('Result not found')
            this.smslogdata = [];
            this.isGetlogisticlogdetails = 1;
            // this.isBusy = false;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    osr_email_details: function(value) {
      this.isBusyosr = true;
      const osremailobj = {
        shippingid: value,
      };
      // console.log("osremailobj",osremailobj);
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getosremaildetails`, osremailobj)
        .then((result) => {
          // console.log("ggggggg",result);
          this.isBusyosr = false;
          if (result.body.returnvalue.length > 0) {
            this.osremaildata = result.body.returnvalue;
          } else {
            this.osremaildata = [];
          }
        })
        .catch((ex) => {
          console.log("error", ex);
          this.isBusyosr = false;
        });
    },
    babygearpushlog: function(value) {
      this.isBusy = true;
      const pushlogobj = {
        shippingid: value,
      };
      // console.log("osremailobj",osremailobj);
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/getwarrantyshipmentbabygearpushlog`,
          pushlogobj
        )
        .then((result) => {
          // console.log("ggggggg",result);
          this.response_msg = result.body.returnmsg;
          // console.log("bbbb",this.response_msg);
          if (result.body.returnmsg === "Successful") {
            // alert("in");
            this.babygeardata = result.body.returnvalue;
            // console.log("babygeardata",this.babygeardata);
            // this.isGetlogisticlogdetails = 1
            this.isBusy = false;
          } else {
            (this.babygeardata = []),
              //alert('Result not found')
              // this.smslogdata = []
              // this.isGetlogisticlogdetails = 1
              (this.response_msg = "");
            this.isBusy = false;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    clear: function() {
      this.customer = {};
      this.searchvaluesarr = [];
      this.ConsignmentMasterGetdata = [];
      this.customlogdata = [];
      this.smslogdata = [];
      this.osremaildata = [];
      this.logisticlogdata = [];
      this.data = [];
      this.dlvstatus = [];
      this.is_mark_ofd = 0;
      this.babygeardata = [];
      this.response_msg = "";
      // this.fields=[];
      this.errors.clear("form-1");
      // var searchlisting = document.getElementById('searchlisting')
      // searchlisting.style.display = 'none'
      // var searchlisting2 = document.getElementById('searchlisting2')
      // searchlisting2.style.display = 'none'
    },
  },

  filters: {
    datechange: function(value) {
      if (value == null) {
        return "-";
      } else {
        var d = new Date(value);
        var curr_date = (d.getDate() < 10 ? "0" : "") + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? "0" + month : "" + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return (
          curr_date + "-" + curr_month + "-" + curr_year + "  " + " " + strTime
        );
      }
    },
  },
};
</script>
<style type="text/css">
.b-table-caption-top {
  color: black;
}
</style>
